import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import JsonTableEditor from "../../atoms/jsonFormEditor/JsonTableEditor";
import LoaderWithProgress from "../../atoms/loader/LoaderWithProgress.js";
import { invokeGetService, invokePostService, handleSnackBar } from "../../../store/global/actions";
import { getNodeNesteData, customizeProfileForm, customizeFormArray } from '../../../services/entities/simulations';
import { profileSchema, formatProfilePayload } from '../../../config/simulation';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { Grid } from '@material-ui/core';
import { validateFormValueType } from '../../../utils/commonUtils.js';
import './style.css'

// const options = {
//     form_name_root: "simulation_profile",
//     show_errors: "never",
//     disable_array_add: true,
//     disable_array_delete: true,
//     disable_array_reorder: true,
//     disable_properties: false,
//     no_additional_properties: false,
//     keep_oneof_values: false
// }

let options = {
    form_name_root: "simulation_profile",
    show_errors: "never",
    disable_collapse: true,
    disable_edit_json: true,
    disable_properties: true,
    remove_button_labels: true,
    disable_array_reorder: true,
    input_width: '100px',
    disable_array_delete_all_rows: true,
    disable_array_delete_last_row: true,
    disable_array_add: false // For hiding + button
}

export default function ProfileSelector({ onClose, onCompletion, action, type, entityId }) {

    const dispatch = useDispatch();
    const [schemaValues, setSchemaValues] = useState({});
    const [loading, setLoading] = useState(false);
    const [allFields, setAllFields] = useState([]);
    const [sections, setAllSections] = useState([]);
    const [profiles, setProfiles] = useState([]);
    const [editorSchema, setEditorSchema] = useState({});
    const [formData, setFormData] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);
    const currentUrl = window.location.href;

    useEffect(() => {
        loadProfileInfo();
    }, [])

    const loadProfileInfo = () => {
        setLoading(true)
        Promise.all([
            dispatch(invokeGetService('getBlueprintConstructs', [])),
        ]).then(([constructs]) => {
            setAllSections(constructs?.data?.sections || []);
            setAllFields(constructs?.data?.fields || []);
            setProfiles(constructs?.data?.clusterlets.filter(cl => cl.type == 6) || [])
            findProfileSchema(constructs?.data?.clusterlets.filter(cl => cl.type == 6), constructs?.data?.sections, constructs?.data?.fields);
            if (action != undefined) {
                dealProfileSchemaData(constructs);
            }
            setLoading(false)
        });
    }


    const transformStructure = (inputStructure, simulationProfile, fields) => {
        const result = {};
        function processChildren(children, obj) {
            children.forEach(child => {
                const childName = child.name;

                if (child.children && child.children.length > 0) {
                    if(child?.attributes?.type === 'table'){
                        obj[childName] = processTableChild(child.children, [])
                    }else{
                        obj[childName] = {}
                    }
                    processChildren(child.children, obj[childName]);
                } else {
                    let fieldVal = simulationProfile.data?.filter(fd => fd.field == child._id)
                    if(!Array.isArray(obj)){
                        fieldVal = fieldVal[0]
                        obj[childName] = {
                            field: '',
                            type: fieldVal?.type ? fieldVal?.type.toLowerCase() : child?.attributes?.type ? child.attributes.type.toLowerCase() : '',
                            value: fieldVal?.value ? fieldVal?.value : '',
                            nodeId: child._id
                        }; 
                    }
                }




            });
        }

        function processTableChild(children, obj) {
            const innerObj = {}
            let length = 0;
            for(let i=0; i<children?.length;i++){
                const child = children[i];
                let fieldVal = simulationProfile.data?.filter(fd => fd.field == child._id)
                length = fieldVal?.length > length ? fieldVal?.length : length
                if(fieldVal?.length === 0 && length > 0){
                    innerObj[child.name] = [...Array(length)].map((item) => {
                        return {
                            field: '',
                            type: child.attributes.type.toLowerCase(),
                            value: '',
                            nodeId: child._id
                        }
                    })
                }else{
                    innerObj[child.name] = fieldVal.map((item) => {
                        return {
                                field: '',
                                type: item?.type ? item?.type.toLowerCase() : child?.attributes?.type ? child.attributes.type.toLowerCase() : '',
                                value: item?.value ? item?.value : '',
                                nodeId: child._id
                            }
                    })
                }
            }

            const keys = Object.keys(innerObj);

            for(let i=0; i< length; i++){
                let newObj = {}
                keys.forEach(key => {
                    newObj[key] = innerObj[key]?.[i] || {}
                })
                obj.push(newObj)
            }

            return obj;
        }

        inputStructure.forEach(section => {
            const sectionName = section.name;
            result[sectionName] = {};

            if (section.children && section.children.length > 0) {
                processChildren(section.children, result[sectionName]);
            }
        });

        return result;
    }



    const generateProfileSchemaData = (profile, sections, fields) => {
        
        const associatedFields = getNodeNesteData(profile, sections, fields);

        const payloadschemaData = transformStructure(associatedFields, action.item, fields);
        console.log("action?.item-------", action?.item)
        let profileObj = {}
        
        profileObj[action?.item?.profile_id] = action?.item?.profile_id;
        profileObj["instance"] = action?.item?.instance;
        profileObj["profile"] = payloadschemaData;
        profileObj["description"] = action?.item?.description ? action?.item?.description : "";
        return profileObj;
    }


    const dealProfileSchemaData = (constructs) => {

        let schemaData = {};

        let selectedprofile = (constructs?.data?.clusterlets.filter(cl => cl.type == 6) || []).find(profile => profile._id == action?.item?.profile_id)

        if (action.item) {
            const payloadschemaData = generateProfileSchemaData(selectedprofile, constructs.data.sections, constructs.data.fields);
            schemaData["profile"] = payloadschemaData

        }
        setSchemaValues(schemaData)

    }

    const findProfileSchema = (profiles, sections, fields) => {
        const profileSchemaResp = profileSchema(profiles, sections, fields);
        const schema = { ...profileSchemaResp, properties: { ...profileSchemaResp.properties } };
        setEditorSchema(schema);
    }


    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    const onChangeJsonEditor = (data) => {
        setFormData(data);
        customizeProfileForm(data); 
        customizeFormArray(data)
    }

    function flattenObject(obj, parentKey = '') {
        let result = [];
        for (let key in obj) {
            let currentKey = parentKey ? `${parentKey}[${key}]` : `[${key}]`;
            if (typeof obj[key] === 'object' && !(obj[key].hasOwnProperty("type") && obj[key].hasOwnProperty("value"))) {
                result = result.concat(flattenObject(obj[key], currentKey));
            } else {
                result.push({
                    key: currentKey,
                    field: obj[key].field,
                    type: obj[key].type,
                    value: obj[key].value,
                    nodeId: obj[key].nodeId
                });
            }
        }
        return result;
    }
    
    const clearErrors = () => {
        const errorDivs = document.querySelectorAll('.validation-error');
        for (let i = 0; i < errorDivs.length; i++) {
          errorDivs[i].remove();
        }
      };

    const onUpdateEvent = () => {
        setIsUpdating(true)
        clearErrors();

        if (Object.keys(formData?.profile).length === 0) {
            const profileDropdown = document.querySelector('select.form-control.je-switcher');
            if (profileDropdown) {

                const validateError = document.getElementById("profile-validation-error");
                if (validateError === null) {
                    profileDropdown.insertAdjacentHTML('afterend', `<p id="profile-validation-error" class="text text-danger validation-error" >Please select profile</p>`);
                }

            }

            setIsUpdating(false);
            return;

        }

        if (formData?.profile?.instance == "") {

            const profileInstance = document.getElementById('simulation_profile[profile][instance]');
            if (profileInstance) {
                const validateError = document.getElementById("instance-validation-error");
                if (validateError === null) {
                    profileInstance.insertAdjacentHTML('afterend', `<p id="profile-validation-error" class="text text-danger validation-error" >Please enter instance</p>`);
                }
            }
            setIsUpdating(false);
            return;
        }

        const profileKeys = Object.keys(formData?.profile);
        let profileId = formData?.profile[profileKeys[0]];

        let singleProfile = profiles.find(profile => profile._id == profileId)

        const flattenProfile = flattenObject(formData?.profile?.profile);
        const validationErrors = validateFormValueType(flattenProfile);
        
        if (validationErrors.length > 0) {
            validationErrors.forEach(item => {
                const inputField = document.getElementById(`simulation_profile[profile][profile]${item.key}[value]`);
                if (inputField) {
                    inputField.insertAdjacentHTML('afterend', `<p id="validation-error-${item.key}" class="text text-danger validation-error" >${item.message}</p>`);
                }
            });
            setIsUpdating(false);
            return;
        }

        let profileObj = {
            profileId: profileId,
            instance: formData?.profile?.instance ? formData?.profile?.instance : '',
            data: formatProfilePayload(formData?.profile?.profile, allFields, sections, profileId),
            description: formData?.profile?.description ? formData?.profile?.description : ""
            // name: singleProfile.name ? singleProfile.name : ''
        }

        if (action != undefined && action.action == "edit_profile") {
            dispatch(invokePostService(type === 'testcase' ? 'updateTestcaseProfile' : 'updateTestsuiteProfile', { profileData: profileObj }, [entityId, action.id])).then(response => {
                setIsUpdating(false);
                if (response.status == true) {
                    onCompletion("add", 'Profile', response.message);
                } else {
                    if (response.status == false) {
                        dispatch(handleSnackBar({ open: true, message: response.message ? response.message : 'Something went wrong', severity: 'error' }));
                    }
                    if (response.code === 255) {
                        // const { slug, blueprintId } = getDetailsFromUrl();
                        // history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                        // dispatch(setReRender());
                    }
                }

            });
        }else {
            dispatch(invokePostService(type === 'testcase' ? 'createTestcaseProfile' : 'createTestsuiteProfile', { profileData: profileObj }, [entityId]))
                .then(response => {
                    setIsUpdating(false);
                    if (response.status == true) {
                        onCompletion('add', 'Profile', response.message);
                    } else {
                        if (response.status == false) {
                            dispatch(handleSnackBar({ open: true, message: response.message ? response.message : 'Something went wrong', severity: 'error' }));
                        }
                        if (response.code === 255) {
                            // const { slug, blueprintId } = getDetailsFromUrl();
                            // history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                            // dispatch(setReRender());
                        }
                    }

                });

        }

    }

    return (
        <>
            {loading ?
                <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '28vh' }} />
                :
                <JsonTableEditor options={options} schema={editorSchema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId="profile_editor" />
            }
            <Grid item xs={12} style={loading ? { display: "flex", justifyContent: "flex-end", marginBottom: 20, marginTop: "30vh" } : { display: "flex", justifyContent: "flex-end", marginTop: 30 }}>
                <UpdateCancel updateDisable={isUpdating || loading} content={(action?.action == "edit_profile" && !isUpdating) ? "Update" : (action?.action == "edit_profile" && isUpdating) ? "Updating.." : isUpdating ? "Creating.." : "Create"} onUpdate={onUpdateEvent} onCancel={onClose} typesNotIn={['transaction', 'view', 'simulation']} />
            </Grid>
        </>
    )


}
